import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { getWorkspaceAlertsNavigationAllowed } from "../../getWorkspaceAlertsNavigationAllowed";

const MessagingAlertsPage = lazy(() =>
  import("@scenes/WorkspaceAlerts").then((module) => ({
    default: module.MessagingAlertsPage,
  }))
);

export const workspaceAlertsMessagingNRO: NavigationRoutingObject = {
  Component: MessagingAlertsPage,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("workspace-alerts-messaging-nro-heading", "Messaging Alerts"),
  pageNameForTracking: () => "Workspace Alerts - Messaging",
  getDeveloperNavigationAllowed: getWorkspaceAlertsNavigationAllowed,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  // Reached from the Messaging card on the Workspace Alerts page, which search already lists.
  showInSearchResults: false,
  defaultRoute: "/app_settings/app_settings/product_alerts/messaging/:appGroupId",
};
